import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

/**
 * Emergent OAuth callback handler. Detects `session_id` in the URL fragment,
 * exchanges it with the backend, and redirects to /.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) return;
    handled.current = true;
    const sessionId = decodeURIComponent(match[1]);
    // Clear the fragment
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sessionId });
        toast.success("Signed in with Google");
        window.location.href = "/";
      } catch (e) {
        toast.error("Google sign-in failed");
        navigate("/login");
      }
    })();
  }, [navigate]);

  return null;
}
